import React from "react";
import "./Footer.css";
import AdithyaCV from "../../docs/AdithyaCV.pdf";
import AdiCoverLetter from "../../docs/AdiCoverLetter.pdf";
import { BsFillPersonFill } from "react-icons/bs";
import { AiFillFilePdf } from "react-icons/ai";
import GitIcon from "../../images/git-icon.png";
import LinkedinIcon from "../../images/linkedin-app-icon.png";
import SkypeIcon from "../../images/skype-icon.png";
import ShareIcon from "../../images/share-icon.svg";
import WhatsappIcon from "../../images/whatsapp-icon.png";
import GmailIcon from "../../images/gmail-icon.png";

const Footer = () => {
  const url = "https://portfolio-eight-blush-47.vercel.app";

  const shareFunction = async () => {
    try {
      await navigator.share({
        text: "Check out Adithya's portfolio for Web Development Purpose",
        url: url,
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="main-footer">
        <div className="notmain-footer">
          <span className="span-footer">
            <BsFillPersonFill
              style={{ color: "white" }}
              className="footer-icon"
            />
            <p className="name-tag">Adithyavarun</p>
          </span>

          <span className="span-footer">
            <img src={GmailIcon} alt="gmail-icon" className="footer-icon" />
            <a className="download-links" href="mailto:adithyavarun95">
              adithyavarun95@gmail.com
            </a>
          </span>

          <span className="span-footer">
            <img
              src={WhatsappIcon}
              alt="whatsapp-icon"
              className="footer-icon"
            />
            <a
              className="download-links"
              href="https://wa.me/917358315322"
              target="_blank"
              rel="noreferrer"
            >
              +91-7358315322
            </a>
          </span>
        </div>

        <div className="docs-footer">
          <span className="span-footer">
            <AiFillFilePdf className="footer-icon" />
            <a
              className="download-links"
              href={AdithyaCV}
              download="CV-Adithya"
            >
              Download CV
            </a>
          </span>

          <span className="span-footer">
            <AiFillFilePdf className="footer-icon" />
            <a
              className="download-links"
              href={AdiCoverLetter}
              download="CoverLetter-Adithya"
            >
              Download Cover Letter
            </a>
          </span>
        </div>

        <div className="notmain-footer">
          <div className="social-links">
            <span>
              <a
                className="classa"
                href="https://github.com/Adithyavarun-creator"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={GitIcon}
                  style={{ color: "white" }}
                  className="social-link-icon"
                  alt="social-icon"
                />
              </a>
            </span>
            <span>
              <a
                className="classa"
                href="https://www.linkedin.com/in/adithya-varun-9a65b8177/"
                target="_blank"
                rel="noreferrer"
              >
                <span>
                  <img
                    src={LinkedinIcon}
                    className="social-link-icon"
                    alt="link-icon"
                  />
                </span>
              </a>
            </span>

            <span>
              <a
                className="classa"
                href="skype:adithyavarun95?chat"
                target="_blank"
                rel="noreferrer"
              >
                <span>
                  <img
                    src={SkypeIcon}
                    className="social-link-icon"
                    alt="skype-icon"
                  />
                </span>
              </a>
            </span>

            <span>
              <a className="classa" rel="noreferrer">
                <span onClick={shareFunction}>
                  <img
                    src={ShareIcon}
                    className="social-link-icon"
                    alt="skype-icon"
                  />
                </span>
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
